import { Navigation, A11y, Pagination } from 'swiper';

export const sliderSettings = (name) => {
    return {
        modules: [Navigation, A11y, Pagination],
        navigation: {
            nextEl: '.swiper-button-next-unique-' + name,
            prevEl: '.swiper-button-prev-unique-' + name
        },
        pagination: {
            el: '.js-content-grid-video-slider-pagination',
            clickable: true,
            renderBullet: (index, className) =>
                `<span class="${className}"></span>`
        },
        watchSlidesProgress: true,
        slidesPerView: 3.28,
        slidesPerGroup: 3,
        spaceBetween: 12,
        slidesOffsetBefore: 48,
        style: {
            marginLeft: '-48px'
        }
    };
};

export const BREAKPOINTS_FOR_FOUR_SLIDES = {
    breakpoints: {
        1024: {
            slidesPerView: 4.28,
            slidesPerGroup: 4,
            spaceBetween: 16
        }
    }
};
